import { ExportType } from '@components'

import { type ExportDocumentFileType } from '@features/exports/types/exportDocumentFileType'

export const contactsExportFileTypes: ExportDocumentFileType[] = [ExportType.Csv, ExportType.Xlsx]

export const defaultContactsExportFileType: ExportDocumentFileType = ExportType.Csv
